import { ComponentProps, ReactNode, useEffect } from 'react';
import { InputLabel } from './InputLabel';
import './ScrollBar.css';

export const TextArea = ({
  value,
  onChange,
  label,
  inputProps,
  className,
  error,
  maxLength,
}: {
  value: string;
  onChange: (val: string) => any;
  inputProps?: ComponentProps<'textarea'>;
  label?: ReactNode;
  className?: string;
  error?: string;
  maxLength?: number;
}) => {
  useEffect(() => {
    if (typeof maxLength === 'undefined') return;
    if (value.length > maxLength) {
      onChange(value.slice(0, maxLength));
    }
  });

  return (
    <div {...{ className }}>
      <InputLabel {...{ label }} />

      <div
        className={`
          h-full
          relative border-2
          ${
            error
              ? 'border-secondary focus-within:border-secondary'
              : 'border-[#e5e7eb] focus-within:border-primary'
          }
        bg-white pl-2 pr-0 pt-[8px] pb-[8px] rounded-lg transition-colors
        `}
      >
        <textarea
          {...inputProps}
          className={`
          nice-scrollbar  outline-0 !border-none border-[#6367ef] !p-0 font-medium bg-transparent w-full min-h-[100px] ${
            inputProps?.className ?? ''
          }`}
          style={{ backgroundColor: 'blue', ...inputProps?.style }}
          value={typeof value !== 'undefined' ? `${value}` : ''}
          onChange={(e) => onChange(e.target.value)}
        />
        {typeof maxLength !== 'undefined' ? (
          <span className="absolute right-2.5 bottom-0 text-gray-400 text-xs z-1">
            {maxLength - value.length}
          </span>
        ) : null}
      </div>
    </div>
  );
};
